import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/modules/auth";
import { useGlobalStore } from "@/stores/modules/global";
import { LOGIN_URL, ROUTER_WHITE_LIST } from "@/config";
import { staticRouter, errorRouter } from "@/routers/modules/staticRouter";
import i18n from "@/language";
import NProgress from "@/config/nprogress";

const i18nGlobal = i18n.global as any;
const router = createRouter({
	history: createWebHistory(),
	routes: [...staticRouter, ...errorRouter],
	strict: false,
	scrollBehavior: (to, form, savePosition) => {
		if (savePosition) {
			// 从列表页跳转到详情页返回,初始在原来位置
			return savePosition;
		} else {
			// 回到顶部
			return { top: 0, left: 0 };
		}
	}
});

/**
 * @description 路由拦截 beforeEach
 * */
router.beforeEach(async (to, from, next) => {
	const authStore = useAuthStore();
	const globalStore = useGlobalStore();
	// 1.NProgress 开始
	NProgress.start();
	// 2.动态设置标题

	const appTitle = globalStore.websiteGet?.name ?? "";
	document.title = to.meta.title ? `${i18nGlobal.t("router." + to.meta.title)} | ${appTitle}` : appTitle;

	// 3.判断是访问登陆页，有 Token 就在当前页面，没有 Token 重置路由到登陆页
	if (to.path.toLocaleLowerCase() === LOGIN_URL) {
		if (authStore.tokenGet) return next(from.fullPath);
		return next();
	}

	// 4.判断访问页面是否在路由白名单地址(静态路由)中，如果存在直接放行
	if (ROUTER_WHITE_LIST.includes(to.name as string)) {
		return next();
	}

	// 5.判断是否有 Token，没有重定向到 login 页面
	if (!authStore.tokenGet) {
		return next({ path: LOGIN_URL, replace: true });
	}

	// 8.正常访问页面
	next();
});

/**
 * @description 路由跳转错误
 * */
router.onError(error => {
	NProgress.done();
	console.warn("路由错误", error.message);
});

/**
 * @description 路由跳转结束
 * */
router.afterEach(() => {
	NProgress.done();
});

export default router;
